import React from "react";

import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/ThirdpartyDataHubStyle";

import { Link, Typography } from "@mui/material";


function DataHubBlock({ label, value }) {
  const { classes } = useStyles();
  return (
    <div className={classes.typoLineWrapper}>
      <Typography className={classes.typoLabel}> {label === "" ? "" : label + ":"}  </Typography>
      {value.startsWith("http") ? (
        <Link href={value} className={classes.typoLink} target="_blank" rel="noopener">{value}</Link>
      ) : (
        <Typography className={classes.typoContent}> {value} </Typography>
      )}
      <br />
    </div>
  )
}

export default DataHubBlock;
